import React from 'react';
export default function Cover({ image, className, ...rest }) {
  return (
    <div
      className={"cover "
        + (className ? className : (!image ? "h-28" : "h-48"))
        + (!image ? " bg-primary text-neutral-content" : "")
      }
    >
      <figure>
        { image && (
          <img src={image} alt="" width="100%"/>
        )}        
      </figure> 
    </div>    
  )
}
